function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 8.15033V15.9668C18 18.1943 16.2091 20 14 20H4C1.79086 20 0 18.1943 0 15.9668V8.15033C0 6.93937 0.539645 5.7925 1.46986 5.02652L6.46986 0.909348C7.9423 -0.303114 10.0577 -0.303117 11.5301 0.909345L16.5301 5.02652C17.4604 5.7925 18 6.93937 18 8.15033ZM9 10.0001L9.30936 9.69076C10.1636 8.83649 11.5487 8.83649 12.403 9.69076C13.2572 10.545 13.2572 11.9301 12.403 12.7844L10.2374 14.9499C9.55402 15.6333 8.44598 15.6333 7.76256 14.9499L5.59705 12.7844C4.74278 11.9301 4.74278 10.545 5.59705 9.69076C6.45132 8.83649 7.83637 8.83649 8.69064 9.69076L9 10.0001Z"
});

var SvgMallFill = function SvgMallFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMallFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mall-fill.fd0564d5.svg";
export { ForwardRef as ReactComponent };